import React from "react";
import styles from "./Style.module.css";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/styles";

function NoDataFound() {
  const theme = useTheme();

  return (
    <div>
      <div className={styles.noResults}>
        <div className={styles.noData}>
          <img
            src={require("../../../../assets/img/ic_search_empty@2x.png")}
            height={140}
            width={140}
            style={{ marginTop: "25px" }}
            className={styles.noData}
          />
        </div>
        <Typography variant="subtitle1" color={theme.palette.text.secondary}>
          No results found
        </Typography>
        <div style={{ fontSize: "0.7rem", fontWeight: "500" }}>
          No matching entries available in our record
        </div>
      </div>
    </div>
  );
}

export default NoDataFound;
